import { RouteRecordRaw } from "vue-router";
import ReportsView from "./views/ReportsView.vue";
import StudentsView from "./views/StudentsView.vue";
import ActivityView from "./views/ActivityView.vue";
import JourneysView from "./views/JourneysView.vue";
import ConceptsView from "./views/ConceptsView.vue";
import AdminView from "./views/AdminView.vue";
import SuperAdminView from "./views/SuperAdmin.vue";
import OverviewPage from "./views/OverviewPage.vue";
import InternalView from "./views/InternalView.vue";
import InternalArchiveView from "./views/InternalArchiveView.vue";
import InternalWondeImportView from "./views/InternalWondeImportView.vue";
import IncompleteRolloverView from "./views/IncompleteRolloverView.vue";
import ReviewClassStructureView from "./views/ReviewClassStructureView.vue";
import AddStudentView from "./views/AddStudentView.vue";
import AddStudentToClassView from "./views/AddStudentToClassView.vue";
import RolloverInProgressVue from "./views/RolloverInProgress.vue";
import ProfileView from "./views/ProfileView.vue";
import TeachersView from "@/modules/main/views/TeachersViewNew.vue";
import ClassesView from "@/modules/main/views/ClassesViewNew.vue";
import StudentView from "@/modules/main/views/StudentViewNew.vue";
import BulkAddEditStudents from "@/modules/main/views/BulkAddEditStudentsNew.vue";
import LingoWordUploadMetaView from "@/modules/main/views/LingoWordUploadMetaView.vue";
import LingoDataView from "./views/manage/LingoDataView.vue";
import LingoLevelsGapsFilledView from "./views/manage/LingoLevelsGapsFilled.vue";

import { useSchoolStore } from "@/stores/schoolStore";
import LingoStudentDataView from "./views/manage/LingoStudentDataView.vue";
import LingoStudentSpellingListView from "./views/manage/LingoStudentSpellingListView.vue";
import LingoStudentVocabularyListView from "./views/manage/LingoStudentVocabularyListView.vue";
import LingoStudentGrammarListView from "./views/manage/LingoStudentGrammarListView.vue";
import LingoSpellingWordDetailView from "./views/manage/LingoStudentSpellingKC.vue";
import LingoVocabularyWordDetailView from "./views/manage/LingoStudentVocabularyKC.vue";
import LingoGrammarKcDetailView from "./views/manage/LingoStudentGrammarKC.vue";
import { NavigationGuardNext } from "vue-router";

const requireLingoV2 = (_to: unknown, _from: unknown, next: NavigationGuardNext) => {
  const school = useSchoolStore();
  if (school.lingoMode === 'v2' || school.lingoMode === 'both') return next();
  next("/main/overview");
};

// Grammar routes are gated on the school's own Grammar setting, so the views
// are unreachable by direct URL for schools that have it switched off in Edit
// School.
const requireGrammar = (to: unknown, from: unknown, next: NavigationGuardNext) => {
  if (!useSchoolStore().grammarEnabled) return next("/main/overview");
  return requireLingoV2(to, from, next);
};

export const mainRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: (to) => {
      const school = useSchoolStore();

      console.log(`school.lingoMode: ${school.lingoMode}`);

      // Route English-only Lingo V2 schools to Lingo Data page
      if (school.lingoMode === 'v2' && school.isEnglishOnlySchool) {
        return "/main/lingo-data";
      }

      // Default to overview for V1 schools
      return "/main/overview";
    },
  },
  {
    path: "overview",
    component: OverviewPage,
    name: "overview",
    beforeEnter: (_to, _from, next) => {
      const school = useSchoolStore();
      if (school.lingoMode === "v2" && school.isEnglishOnlySchool) {
        return next("/main/lingo-data");
      }
      next();
    },
  },
  {
    path: "journeys",
    name: "journeys",
    component: JourneysView,
  },
  {
    path: "concepts",
    name: "concepts",
    component: ConceptsView,
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_CONCEPTS === "true") {
        next();
      } else {
        next("/main/overview");
      }
    },
  },
  {
    path: "reports",
    name: "reports",
    component: ReportsView,
  },
  {
    path: "students",
    name: "students",
    component: StudentsView,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_OLD_STUDENTS_VIEW === "true") {
        next();
      } else {
        next("/main/overview");
      }
    }
  },
  // {
  //   path: "students",
  //   name: "students",
  //   component: StudentsView,
  // },
  {
    path: "activity",
    name: "activity",
    component: ActivityView,
  },
  {
    path: "admin",
    name: "admin",
    component: AdminView,
  },
  {
    path: "super-admin",
    name: "super-admin",
    component: SuperAdminView,
  },
  {
    path: "internal",
    name: "internal",
    component: InternalView,
  },
  {
    path: "profile",
    name: "profile",
    component: ProfileView,
  },
  {
    path: "internal-edit-school",
    name: "internal-edit-school",
    component: InternalView,
  },
  {
    path: "internal-achive",
    name: "internal-achive",
    component: InternalArchiveView,
  },
  {
    path: "internal-wonde-import",
    name: "internal-wonde-import",
    component: InternalWondeImportView,
  },

  {
    path: "incomplete-rollover",
    name: "incomplete-rollover",
    component: IncompleteRolloverView,
    meta: {
      requiresRolloverLearnersReview: true,
    },
  },
  {
    path: "rollover-in-progress",
    name: "rollover-in-progress",
    component: RolloverInProgressVue,
  },
  {
    path: "review-class-structure",
    name: "review-class-structure",
    component: ReviewClassStructureView,
    meta: {
      requiresRolloverClassReview: true,
    },
  },
  {
    path: "add-student",
    name: "add-student",
    component: AddStudentView,
    meta: {
      requiresRolloverExecution: true,
    },
  },
  {
    path: "add-student-to-class/:classId",
    name: "add-student-to-class",
    component: AddStudentToClassView,
    meta: {
      requiresRolloverExecution: true,
    },
  },
  {
    path: "/teachersnew",
    name: "teachersnew",
    component: TeachersView,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_TEACHERS === "true") {
        next();
      } else {
        next("/main/overview");
      }
    }
  },
  {
    path: "/classesnew",
    name: "classesnew",
    component: ClassesView,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_CLASSES === "true") {
        next();
      } else {
        next("/main/overview");
      }
    }
  },
  {
    path: "/studentsnew",
    name: "studentsnew",
    component: StudentView,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_STUDENTS === "true") {
        next();
      } else {
        next("/main/overview");
      }
    }
  },
  {
    name: "BulkAddEditStudent",
    meta: { requiresAuth: true },
    path: "/manage/bulk-add-edit-student",
    component: () => import(/* webpackChunkName: "bulk add edit students page" */ "@/modules/main/views/manage/BulkStudentAddUpdateView.vue"),
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_NEW_BULK_ADD_EDIT_VIEW === "true") {
        next();
      } else {
        next("/main/overview");
      }
    }
  },
  {
    path: "/bulkaddeditstudentsnew",
    name: "bulkaddeditstudentsnew",
    component: BulkAddEditStudents,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_BULK_ADD_EDIT_STUDENTS === "true") {
        next();
      } else {
        next("/main/overview");
      }
    }
  },

  {
    path: "lingo-word-upload-meta",
    name: "lingo-word-upload-meta",
    component: LingoWordUploadMetaView,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (_to, _from, next) => {
      if (process.env.VUE_APP_FEATURE_FLAG_LINGO === "true") {
        next();
      } else {
        next("/main/overview");
      }
    }
  },
  {
    path: "lingo-lists/create",
    name: "lingo-lists-create",
    component: () => import("./views/manage/CreateListView.vue"),
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-lists/:id/assign",
    name: "lingo-lists-assign",
    component: () => import("./views/manage/AssignListView.vue"),
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-lists",
    name: "lingo-lists",
    component: () => import("./views/manage/LingoListsView.vue"),
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-data",
    name: "lingo-data",
    component: LingoDataView,
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-data/levels-gaps-filled",
    name: "lingo-levels-gaps-filled",
    component: LingoLevelsGapsFilledView,
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-data/student/:studentId",
    name: "lingo-student-data",
    component: LingoStudentDataView,
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-levels-gaps/student/:studentId",
    name: "lingo-student-levels-gaps",
    component: () => import("./views/manage/LingoLevelsAndGapsFilledView.vue"),
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-spelling-list/student/:studentId",
    name: "lingo-student-spelling-list",
    component: LingoStudentSpellingListView,
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },
  {
    path: "lingo-vocabulary-list/student/:studentId",
    name: "lingo-student-vocabulary-list",
    component: LingoStudentVocabularyListView,
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },

  {
    path: "lingo-grammar-list/student/:studentId",
    name: "lingo-student-grammar-list",
    component: LingoStudentGrammarListView,
    meta: { requiresAuth: true },
    beforeEnter: requireGrammar
  },

  {
    path: "lingo-spelling-word/:studentId/:kcId",
    name: "lingo-spelling-word-detail",
    component: LingoSpellingWordDetailView,
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },

  {
    path: "lingo-vocabulary-word/:studentId/:kcId",
    name: "lingo-vocabulary-word-detail",
    component: LingoVocabularyWordDetailView,
    meta: { requiresAuth: true },
    beforeEnter: requireLingoV2
  },

  {
    path: "lingo-grammar-kc/:studentId/:kcId",
    name: "lingo-grammar-kc-detail",
    component: LingoGrammarKcDetailView,
    meta: { requiresAuth: true },
    beforeEnter: requireGrammar
  },

];
